import { FormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { ObjetivoService } from '../../services/objetivo.service';
import { IpPublicService } from 'src/app/services/ip-public.service';
import { Subject, forkJoin, map, mergeMap } from 'rxjs';
import { AlertService } from 'src/app/services/alert.service';
import { DataTableDirective } from 'angular-datatables';
import { ModalService } from 'src/app/services/modal.service';
import { EquipoGerencialService } from 'src/app/modulos/catalogos-proces/services/equipo.gerencial.service';
import { ParticipanteElementoService } from '../../services/participante.elemento.service';
import { LineaAccionService } from '../../services/linea-accion.service';
import { LineaAccionInterface } from '../../models/linea-accion';
import { EstrategiasService } from '../../services/estrategias.service';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TreeNode } from "primeng/api";
import { UnidadesSiipneService } from 'src/app/services/unidades-siipne.service';
import { EstrategiaObjetivoService } from '../../services/estrategia-objetivo.service';
import { ConstantsCatalogosIdService } from 'src/app/services/constants-catalogos-id.service';
import { validadorFechaIntervalo } from 'src/app/helpers/validator-form';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { UsuarioRedux } from 'src/app/models/usuario.model';
import { ComunService } from 'src/app/modulos/catalogos-proces/services/comun.service';
import { AniosObjetivosService } from 'src/app/modulos/catalogos-admin/services/anios-objetivos.service';
import { RiesgosService } from '../../services/riesgos.service';
import { ActividadesService } from '../../services/actividades.service';


@Component({
  selector: 'app-linea-accion',
  templateUrl: './linea-accion.component.html',
  styleUrls: ['./linea-accion.component.css']
})
export class LineaAccionComponent implements OnInit, OnDestroy {
  breadCrumbItems = [
    { label: 'Formulación Planes' },
    { label: 'Elementos' },
    { label: 'Lineas de Acción', active: true },
  ];
  public formLineaAccion: UntypedFormGroup;
  public submitted = false;
  public dataLineasObjetivos: any = [];
  public dataObjetivo: any = [];
  public dataLineaAccion: any[] = [];
  private idDeleteRegister: number = 0;
  private currentUser!: any;
  private ipAddress!: string;
  private buffer!: any;
  public nameApp = 'LÍNEAS DE ACCIÓN';
  public selectItems: any = [];
  private idSprAmbiente: number = 0;
  public dataEquipoGerencial!: any;
  public nombreObjetivos = [];
  //Variable que almacena el plan Años seleccionado
  public planAnioSeleccionadoRedux: any = null;
  //Array que almacena los ids de los objetivos del plan anual seleccionado
  public dataObjetivosPorAnio: any = [];

  public objetivo: any = null;
  fechaIniciObjetivo: any;
  fechaFinObjetivo: any;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  isDtInitialized: boolean = false;


  @ViewChild('modalChild') myModal: any;

  public dataEstrategiaObjetivo!: any;
  public nameModal: string = 'modalLineaAccion';
  public modalActividad: string = 'modalActividadesLineas'
  tituloActividad = 'ACTIVIDADES';
  public dataEstrategiaL: any = [];
  public dataEstrategiaMap: any = [];
  public dataEstragiasActivas: any = [];
  unidades: TreeNode[];
  selectedFile: TreeNode;
  public nombreRuta: any = '';
  public dataParticipantesElemento!: any;
  public dataTipoLineaAccion!: any;
  public outDataLineaAccion: any;
  public idLineaAccion: any;
  public participanteElementoAeliminar = [];
  public dataPersonalElementoL!: any;
  public dataEquipoGerencialL!: any;
  public dataLineaAccionEquipo!: any;
  public participanteElemento: any = [];
  inputsAnteriores = [];
  public patrocinadorOriginal: any;
  public guardarEquipoGerencialSeleccionado: any;
  public idSprParticipanteElementoM!: any;
  public idSprAnio: number = 0;
  public idSprPlanAnio: number = 0;
  public idSprUsuarioApp: any;
  public estadoActivo: number = 1; //traer los que estan en estado activo 

  //Almacena el usuario actual disponible en Redux
  currentUserRedux: UsuarioRedux = null;

  public dataPlanesAnios: any = [];
  public idSprParticipanteElemento: number = 0;
  public dataRiesgos!: any;
  public dataActividades!: any;
  public idSprNivel: number = 0;
  readonly constant = ConstantsCatalogosIdService;
  public idSprTipoParticipante = ConstantsCatalogosIdService.ID_COMUNES_PARTICIPANTE;
  public idEquipoLineAccion = ConstantsCatalogosIdService.ID_COMUNES_EQUIPO_LINEAS_ACCION;
  public idTipoLineaAccion = ConstantsCatalogosIdService.ID_COMUNES_TIPO_LINEA_PLAN_DE_ACCION;



  constructor(
    private estrategiasService: EstrategiasService,
    public estrategiaObjetivoService: EstrategiaObjetivoService,
    private unidadesSiipneService: UnidadesSiipneService,
    private alertService: AlertService,
    public modal: ModalService,
    private lineaAccionService: LineaAccionService,
    private ip: IpPublicService,
    private fb: FormBuilder,
    private comunService: ComunService,
    private objetivoService: ObjetivoService,
    private participanteElementoService: ParticipanteElementoService,
    private equipoLineasAccionService: EquipoGerencialService,
    private equipoGerencialService: EquipoGerencialService,
    public store: Store<AppState>,
    private planAniosService: AniosObjetivosService,
    private riesgosService: RiesgosService,
    private actividadesService: ActividadesService,
  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
    this.selectItems = [
      { value: '', label: 'Selecione..' },
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];

  }

  setFormLinea(dataRowObjetivo: any = []) {
    let idSprObjetivo = dataRowObjetivo.idSprObjetivo
    this.fechaIniciObjetivo = dataRowObjetivo.fechaInicioObjetivo
    this.fechaFinObjetivo = dataRowObjetivo.fechaFinObjetivo
    this.formLineaAccion = this.fb.group({
      idSprObjetivo: [idSprObjetivo],
      idSprLineaAccion: [],
      idSprEstrategia: ['', [Validators.required]],
      idSprTipoLineaAccion: ['', [Validators.required]],
      nombre: ['', [Validators.required]],
      descripcion: ['', [Validators.required]],
      fechaInicio: ['', [Validators.required, validadorFechaIntervalo(this.fechaIniciObjetivo, this.fechaFinObjetivo)]],
      fechaFin: ['', [Validators.required, validadorFechaIntervalo(this.fechaIniciObjetivo, this.fechaFinObjetivo)]],
      objetivoGeneral: ['', [Validators.required]],
      objetivoEspecifico: ['', [Validators.required]],
      estado: ['', [Validators.required]],
      idSprEquipoGerencial: ['', [Validators.required]],
      /***set localidad de impacto ***/
      localidadImpacto: ['', [Validators.required]],//para la localidad de impacto
      idDgpUnidad: [],//para la localidad de impacto
      /*** Fin set localidad de impacto */
    });
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }
  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  ngOnInit(): void {
    this.store.select("globalApp").subscribe((response) => {// redux
      this.planAnioSeleccionadoRedux = response.planAniosSeleccionado;
      this.idSprAmbiente = response.ambienteSeleccionado.idSprAmbiente;
      this.idSprNivel = response.ambienteSeleccionado.nivel.idSprNivel;
      this.idSprAnio = response.planAniosSeleccionado.idSprAnio;
      this.idSprPlanAnio = response.planAniosSeleccionado.idSprPlanAnio;
      this.initApp();
    });

    this.store.select("usuarioApp").subscribe((response) => {
      this.currentUserRedux = response.currentUser;
      this.idSprUsuarioApp = response.currentUser.idSprUsuario;

    });
  }

  initApp() {
    this.setDataTable();
    this.listRiesgos();
    this.listActividades();
    this.getIpPublic();
    this.setFormLinea();
    this.getDataParticipantes();
    this.listTipoLineaAccion();
    this.getTreeUnidadesSiipne();
    this.getDataAll();

  }

  listPlanAnios() {
    this.planAniosService.list('?idSprAnio=' + this.idSprAnio).subscribe({
      next: (resp) => {
        this.dataPlanesAnios = resp;
        this.idSprPlanAnio = resp[0].idSprPlanAnio;
      }
    })

  }

  getDataAll() {
    forkJoin([
      this.objetivoService.list('?idSprAmbiente=' + this.idSprAmbiente + '&idSprPlanAnio=' + this.idSprPlanAnio + '&estado=' + this.estadoActivo),
      this.estrategiaObjetivoService.list('?nivelSuperior=' + 'N'),
      this.estrategiasService.list('?idSprAmbiente=' + this.idSprAmbiente + '&estado=' + this.estadoActivo),
      this.lineaAccionService.list(),
    ]).pipe(map(
      ([dataObjetivo, dataEstrategiaObjetivo, dataEstrategiaL, dataLineaAccion]) => {
        this.dataObjetivo = dataObjetivo;
        this.dataEstrategiaObjetivo = dataEstrategiaObjetivo;
        this.dataEstrategiaL = dataEstrategiaL;
        this.dataLineaAccion = dataLineaAccion;
        this.mapDataLineasObjetivos();
      })).subscribe();
  }


  getParticipanteElemento() {
    this.participanteElementoService.list().subscribe((resp) => {
      this.dataPersonalElementoL = resp;
      this.getEquipoGerencial();
    })
  }

  getEquipoGerencial() {
    this.equipoGerencialService.list().subscribe((resp) => {
      this.dataEquipoGerencialL = resp;
    })
  }

  mapDataLineasObjetivos() {
    this.dataLineasObjetivos = []
    let indiceUno = 0;
    let dataProcess: any = [];
    let equipoLineMap: any = [];
    for (let i = 0; i < this.dataObjetivo.length; i++) {
      for (let j = 0; j < this.dataEstrategiaObjetivo.length; j++) {
        if (this.dataObjetivo[i].idSprObjetivo == this.dataEstrategiaObjetivo[j].idSprObjetivo) {
          for (let k = 0; k < this.dataEstrategiaL.length; k++) {
            if (this.dataEstrategiaL[k].idSprEstrategia == this.dataEstrategiaObjetivo[j].idSprEstrategia) {
              for (let l = 0; l < this.dataLineaAccion.length; l++) {
                if (this.dataEstrategiaL[k].idSprEstrategia == this.dataLineaAccion[l].idSprEstrategia) {

                  dataProcess.push({
                    idSprObjetivo: this.dataObjetivo[i].idSprObjetivo,
                    nombreObjetivo: this.dataObjetivo[i].nombre,
                    idSprEstrategia: this.dataEstrategiaL[k].idSprEstrategia,
                    nombreEstrategia: this.dataEstrategiaL[k].nombre,
                    idSprLineaAccion: this.dataLineaAccion[l].idSprLineaAccion,
                    nombreLineaAccion: this.dataLineaAccion[l].nombre,
                    descripcion: this.dataLineaAccion[l].descripcion,
                    objetivoGeneral: this.dataLineaAccion[l].objetivoGeneral,
                    objetivoEspecifico: this.dataLineaAccion[l].objetivoEspecifico,
                    idSprTipoLineaAccion: this.dataLineaAccion[l].idSprTipoLineaAccion,
                    idSprT: this.dataLineaAccion[l].idSprT,
                    fechaInicio: this.dataLineaAccion[l].fechaInicio,
                    fechaFin: this.dataLineaAccion[l].fechaFin,
                    estado: this.dataLineaAccion[l].estado,
                    localidadImpacto: this.dataLineaAccion[l].localidadImpacto,
                    equipoLineMap: equipoLineMap,
                    nombreElemento: this.nameModal,
                  }); indiceUno++;
                }
              }

            }
          }
        }
      }
      this.dataLineasObjetivos.push({
        nombreObjetivo: this.dataObjetivo[i].nombre,
        idSprObjetivo: this.dataObjetivo[i].idSprObjetivo,
        fechaInicioObjetivo: this.dataObjetivo[i].fechaInicio,
        fechaFinObjetivo: this.dataObjetivo[i].fechaFin,
        lineaAccion: dataProcess
      }); dataProcess = [];
    }
  }

  getDataParticipantes() {
    this.equipoLineasAccionService.list(
      `?idSprAmbiente=${this.idSprAmbiente}&idSprTipoParticipante=${this.idEquipoLineAccion}&estado=${1}`)
      .subscribe(
        (resp) => {
          this.dataParticipantesElemento = resp
        });
  }

  listTipoLineaAccion() { //trae los tipo de plan  de accion de los catalogos comunes
    this.comunService.list("?spr_idSprComun=" + this.idTipoLineaAccion)
      .subscribe(resp => {
        this.dataTipoLineaAccion = resp;

      })
  }

  onSubmit() {
    this.submitted = true;

    this.formLineaAccion.value.idSprAmbiente = this.idSprAmbiente;
    this.formLineaAccion.value.usuario = this.idSprUsuarioApp;
    this.formLineaAccion.value.ip = this.ipAddress;
    let fechaInicial = this.formLineaAccion.value.fechaInicio;
    let fechaFinal = this.formLineaAccion.value.fechaFin;

    if (fechaInicial > fechaFinal) {
      this.alertService.warning(
        '¡Atención!',
        'La fecha inicial no puede ser mayor a la fecha final.'
      );
      return;
    }

    //Realizar el posteo
    let lineaAccion = {
      idSprAmbiente: this.idSprAmbiente,
      usuario: this.idSprUsuarioApp,
      ip: this.ipAddress,
      idSprEstrategia: this.formLineaAccion.value.idSprEstrategia,
      idSprTipoLineaAccion: this.formLineaAccion.value.idSprTipoLineaAccion,
      idSprLineaAccion: this.formLineaAccion.value.idSprLineaAccion,
      nombre: this.formLineaAccion.value.nombre,
      descripcion: this.formLineaAccion.value.descripcion,
      fechaInicio: this.formLineaAccion.value.fechaInicio,
      fechaFin: this.formLineaAccion.value.fechaFin,
      objetivoGeneral: this.formLineaAccion.value.objetivoGeneral,
      objetivoEspecifico: this.formLineaAccion.value.objetivoEspecifico,
      localidadImpacto: this.formLineaAccion.value.localidadImpacto,
      idSprProceso: null, // verificar
      estado: this.formLineaAccion.value.estado,
      idSprEquipoGerencial: this.formLineaAccion.value.idSprEquipoGerencial,
    };

    let participanteLineaAccion = {
      idSprParticipanteElemento: this.formLineaAccion.value.idSprParticipanteElemento,
      idSprEquipoGerencial: this.formLineaAccion.value.idSprEquipoGerencial,
      idSprLineaAccion: this.formLineaAccion.value.idSprLineaAccion,
      fechaInicio: this.formLineaAccion.value.fechaInicio,
      fechaFin: this.formLineaAccion.value.fechaFin,
      estado: 1,
      ip: this.ipAddress,
      usuario: this.idSprUsuarioApp,
    };

    if (this.formLineaAccion.valid) {
      if (lineaAccion.idSprLineaAccion === null) {
        this.formLineaAccion.value.fechaInicio = fechaInicial;
        this.formLineaAccion.value.fechaFin = fechaFinal;
        this.lineaAccionService.create(lineaAccion)
          .pipe(
            mergeMap((planAccionGuardado) => {
              let suscribciones = [];
              lineaAccion.idSprLineaAccion = planAccionGuardado.idSprLineaAccion;
              participanteLineaAccion.idSprLineaAccion = planAccionGuardado.idSprLineaAccion;
              suscribciones.push(
                this.participanteElementoService.create(participanteLineaAccion)
              );
              return forkJoin(suscribciones);
            })
          )
          .subscribe(
            (data) => {
              this.alertService.createOk();
              this.closeModal();
              this.initApp()
            },
            (err) => {
              this.alertService.createError();
              this.lineaAccionService.delete(lineaAccion).subscribe();
              this.closeModal();
            }
          );
      } else {
        let participanteElemento
        this.participanteElementoService.list(`?idSprLineaAccion=${lineaAccion.idSprLineaAccion}`).subscribe(respParticpaElemento => {
          respParticpaElemento.forEach(
            respuesta => {
              if (respuesta.estado === 1) {
                this.idSprParticipanteElementoM = respuesta.idSprParticipanteElemento
              }
            }
          )
        }
        )
        participanteElemento = {
          idSprParticipanteElemento: this.idSprParticipanteElemento,
          idSprEquipoGerencial: this.formLineaAccion.value.idSprEquipoGerencial,
          idSprLineaAccion: this.formLineaAccion.value.idSprLineaAccion,
          fechaInicio: this.formLineaAccion.value.fechaInicio,
          fechaFin: this.formLineaAccion.value.fechaFin,
          estado: 1,
          ip: this.ipAddress,
          usuario: this.idSprUsuarioApp,
        };
        this.participanteElementoService.update(participanteElemento).subscribe()
        this.lineaAccionService.update(lineaAccion)
          .subscribe(data => {
            this.initApp();
            this.alertService.createOk();
            this.onResetForm();
            this.closeModal();
          }, (err) => {
            this.alertService.createError();
            this.lineaAccionService.delete(lineaAccion).subscribe();
            this.closeModal();
          });
      }
    } else {
      return;
    }
  }

  updateLineaAccion(obj: any, rowDataObjetivo) {
    this.obtenerEstategias(obj)
    this.onResetForm();
    this.nombreObjetivos = obj.nombreObjetivo;
    this.setFormLinea(rowDataObjetivo)
    this.getDataParticipanteElemento(obj.idSprLineaAccion)
    this.formLineaAccion.patchValue({
      idSprObjetivo: obj.idSprObjetivo,
      idSprLineaAccion: obj.idSprLineaAccion,
      idSprEstrategia: obj.idSprEstrategia,
      nombre: obj.nombreLineaAccion,
      descripcion: obj.descripcion,
      fechaInicio: obj.fechaInicio,
      fechaFin: obj.fechaFin,
      objetivoGeneral: obj.objetivoGeneral,
      objetivoEspecifico: obj.objetivoEspecifico,
      localidadImpacto: obj.localidadImpacto,
      idSprProceso: obj.idSprProceso,
      estado: obj.estado,
      idSprAreaElemento: obj.idSprAreaElemento,
      idSprTipoLineaAccion: obj.idSprTipoLineaAccion
    });
    this.modal.open(this.nameModal);
  }

  getDataParticipanteElemento(idSprLineaAccion: number) {
    this.participanteElementoService.list('?idSprLineaAccion=' + idSprLineaAccion)
      .subscribe((res: any) => {
        this.participanteElemento = res
        let participanteElementoPatrocinador: any
        this.inputsAnteriores = []
        res.forEach(participante => {
          this.equipoGerencialService.getById(participante.idSprEquipoGerencial).subscribe((resi: any) => {
            this.patrocinadorOriginal = participante
            participanteElementoPatrocinador = resi
            this.guardarEquipoGerencialSeleccionado = resi
            this.formLineaAccion.patchValue({
              ...this.formLineaAccion.value,
              idSprEquipoGerencial: resi.idSprEquipoGerencial,
              idSprParticipanteElemento: participante.idSprParticipanteElemento
            })
            this.formLineaAccion.value.idSprEquipoGerencial = resi.idSprEquipoGerencial
            this.formLineaAccion.value.idSprParticipanteElemento = participante.idSprParticipanteElemento
            this.idSprParticipanteElemento = participante.idSprParticipanteElemento;
          })
        })
      })
  }


  delete(row: any) {
    this.idDeleteRegister = row.idSprLineaAccion;
    this.modal.open('delete-objetivo');
  }

  verifyAmbRolUsuario() {
    return this.actividadesService.list(`?idSprLineaAccion=${this.idDeleteRegister}&delLog=N`).toPromise();
  }

  async confirmDelete() {
    let confirmDelete = true;
    let dataVerifyRelacion: any = [];
    dataVerifyRelacion = await this.verifyAmbRolUsuario();
    (dataVerifyRelacion.length > 0) ? confirmDelete = false : "";

    if (confirmDelete) {
      this.lineaAccionService.update({
        "idSprLineaAccion": this.idDeleteRegister,
        "usuario": this.idSprUsuarioApp,
        "delLog": "S",
        "ip": this.ipAddress
      }).subscribe(resp => {
        this.modal.close();
        this.alertService.deleteOk();
        this.initApp()
      }, (err) => {
        this.alertService.deleteError();
        this.modal.close();
      });
    } else {
      this.alertService.warning("¡Atención!", "No se puede borrar este registro, existe ACTIVIDADES relacionadas.");
    }
  }


  modalActividades(obj: LineaAccionInterface) {
    this.outDataLineaAccion = obj;
    this.modal.open(this.modalActividad);
    this.formLineaAccion.patchValue({
      idSprLineaAccion: obj.idSprLineaAccion,
    });
    this.idLineaAccion = obj.idSprLineaAccion;
  }

  closeModalActividad(modalActividad: any) {
    this.modal.closeId(modalActividad);
    this.initApp();
    this.setDataTable()
  }

  onResetForm() {
    this.submitted = false;
    this.formLineaAccion.reset();
  }

  openModal(row: any) {
    this.onResetForm();
    this.obtenerEstategias(row)
    this.setFormLinea(row);
    this.nombreObjetivos = row.nombreObjetivo;
    this.modal.open(this.nameModal);
    this.limpiarLocalidadImpacto()

    setTimeout(() => {
      // Verificar que la referencia al modal existe
      if (this.myModal) {
        const scrollableElement = this.myModal.element.querySelector(
          '.modal-dialog-scrollable .modal-body'
        );
        // Verificar que el elemento scrollable existe
        if (scrollableElement) {
          scrollableElement.scrollTop = 0;
        } else {
        }
      } else {
      }
    }, 200);

  }

  obtenerEstategias(row: any) { // metodo para traer estrategias con los objetivos
    this.dataEstrategiaObjetivo
    this.dataEstrategiaL
    let idSprObjetivo = row.idSprObjetivo;
    this.dataEstrategiaMap = []
    this.estrategiaObjetivoService.list('?idSprObjetivo=' + idSprObjetivo + '&nivelSuperior=N').subscribe(data => {
      for (let x = 0; x < data.length; x++) {
        for (let y = 0; y < this.dataEstrategiaL.length; y++) {
          if ((data[x].idSprEstrategia == this.dataEstrategiaL[y].idSprEstrategia)) {
            this.dataEstrategiaMap.push(this.dataEstrategiaL[y])
          }
        }
      }
    })
  }


  closeModal() {
    this.modal.close();
    this.setDataTable()
    this.limpiarLocalidadImpacto()
  }


  get appForm() {
    return this.formLineaAccion.controls;
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }
  setEquipoGenrecial(obj: any, dataParticipantesElemento: any) {
    this.guardarEquipoGerencialSeleccionado =
      dataParticipantesElemento.filter(equipo => {
        return equipo.idSprEquipoGerencial === +obj.value
      })[0]
  }

  /**
   * Para el árbol de unidades
   */

  getTreeUnidadesSiipne() {
    this.unidadesSiipneService.listParents().subscribe((resp: TreeNode[]) => {
      this.unidades = resp;
      this.unidades.forEach(node => {
        this.unidadesSiipneService.listChilds(node.data).subscribe((respChild: TreeNode[]) => {
          node.children = respChild;
        });
      });
    });
  }
  limpiarLocalidadImpacto() {
    const miTextArea = document.getElementById('localidadImpacto') as HTMLTextAreaElement;
    miTextArea.value = "";
    this.nombreRuta = "";
  }
  nodeSelect(evt) {
    this.nombreRuta = (this.nombreRuta) + (" / " + evt.node.label),
      this.formLineaAccion.patchValue({
        idDgpUnidad: evt.node.data,
        localidadImpacto: this.nombreRuta
      });
  }

  nodeExpand(event) {
    if (event.node) {
      this.unidadesSiipneService.listChilds(event.node.data).subscribe(resp => {
        event.node.children = resp;
      });
    }
  }

  //////////////////////////FIN árbol de unidades //////////////////////////

  /**
   * metodo totalRiesgos() retorna numero total de riesgos por cada linea de acción
   */

  listRiesgos() {
    this.riesgosService.list().subscribe(
      resp => {
        this.dataRiesgos = resp;
      }
    )
  }

  totalRiesgos(id: number, dataRiesgos: any[]) {
    return dataRiesgos?.filter((resp) => {
      return resp.idSprLineaAccion === id;
    }
    );
  }

  /**
   * metodo totalActividades() retorna numero total de actividades por cada linea de acción
   */

  listActividades() {
    this.actividadesService.list().subscribe(
      resp => {
        this.dataActividades = resp;
      }
    )
  }

  totalActividades(id: number, dataActividades: any[]) {
    if (!dataActividades) {
      return []; // Si dataActividades es null o undefined, retornar un array vacío
    }
    return dataActividades.filter((resp) => {
      return resp.idSprLineaAccion === id;
    });
  }
}
